import React from 'react';
import cn from 'classnames';

import { DEFAULT_PROGRESS } from './LinearProgressBar.constants';

import { idxMap } from 'helpers/styleMapIdx';

import styles from './LinearProgressBar.module.scss';

const VARIANTS = {
  default: styles.default,
  upload: styles.upload,
};

const LinearProgressBar = ({
  className,
  trackClassName,
  thumbClassName,
  variant,
  progress,
}: {
  className: any;
  trackClassName: any;
  thumbClassName: any;
  variant: any;
  progress: any;
}) => (
  <div
    className={cn(
      styles.bar,
      idxMap(VARIANTS as Record<string, string>, variant),
      className,
    )}
  >
    <div
      className={cn(
        styles.thumb,
        { [styles.progressThumb]: progress > DEFAULT_PROGRESS },
        thumbClassName,
      )}
    >
      <div
        className={cn(styles.track, trackClassName)}
        style={{
          width: `${
            progress > DEFAULT_PROGRESS ? progress : DEFAULT_PROGRESS
          }%`,
        }}
      />
    </div>
  </div>
);

LinearProgressBar.defaultProps = {
  variant: 'default',
};

export default React.memo(LinearProgressBar) as any;
